<template>
  <div class="dataset-select-case-dailog dialog col-block width-full">
    <div class="top-container row-block flex-end">
      <div
        class="top-title"
        v-html="[
          $t('DIALOG.datasetSelectCase.___topTitle01', { count: toPriceString(cases.length) }),
          cases.length ? $t('DIALOG.datasetSelectCase.___topTitle02') : ''
        ].filter(x => x).join(' ')"
      ></div>
      <div class="top-option-container row-block">
        <button v-if="cases.length" class="white-gray-button circle-button" @click="e => $emit('changeModal', {}, cases.map(caseData => caseData.id))">
          <span>{{ $t('COMMON.button.___addAll') }}</span>
        </button>
      </div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <template v-if="cases.length">
      <div :style="{ height: '10px' }"></div>
      <div class="table-search-container row-block">
        <div class="search-title" v-html="'<b>' + toPriceString(selectedTableDatas.length) + '</b> samples are selected.'"></div>
        <div class="search-container input-group" :style="{ width: '420px' }">
          <input type="text" :placeholder="$t('DIALOG.datasetSelectCase.___searchPlaceholder')" v-model="query">
          <img :src="require('../../assets/images/search-solid.svg')" alt="">
        </div>
      </div>
      <div class="table-main-container col-block width-full" :style="{ flex: 1 }">
        <div class="custom-table" :class="{ 'auto-height': false }">
          <div
            v-if="tableWidths"
            class="table-field col-block grab-container"
            :style="{ width: tableWidths.reduce((s, c) => s + c.value, 0) + 'px' }"
            @mousedown.left="e => boardEvent('board1', e, [boardStart])"
            @mousemove="e => boardEvent('board1', e, [boardMove])"
            @mouseout="e => boardEvent('board1', e, [boardMove])"
            @mouseup.left="e => boardEvent('board1', e, [boardEnd])"
          >
            <!-- line -->
            <div class="grab-line x min" :style="lineData.x.min && lineData.x.min.display ? { left: lineData.x.min.value + 'px', display: 'block' } : {}"></div>
            <div class="grab-line x max" :style="lineData.x.max && lineData.x.max.display ? { left: lineData.x.max.value + 'px', display: 'block' } : {}"></div>
            <div class="grab-line x main" :style="lineData.x.main && lineData.x.main.display ? { left: (lineData.x.main.base + lineData.x.main.grab) + 'px', display: 'block' } : {}"></div>
            <div class="grab-line x custom" :style="lineData.x.custom && lineData.x.custom.display ? { left: lineData.x.custom.value + 'px', display: 'block' } : {}"></div>
            <div class="grab-line y min" :style="lineData.y.min && lineData.y.min.display ? { top: lineData.y.min.value + 'px', display: 'block' } : {}"></div>
            <div class="grab-line y max" :style="lineData.y.max && lineData.y.max.display ? { top: lineData.y.max.value + 'px', display: 'block' } : {}"></div>
            <div class="grab-line y main" :style="lineData.y.main && lineData.y.main.display ? { top: (lineData.y.main.base + lineData.y.main.grab) + 'px', display: 'block' } : {}"></div>
            <div class="grab-line y custom" :style="lineData.y.custom && lineData.y.custom.display ? { top: lineData.y.custom.value + 'px', display: 'block' } : {}"></div>
            <!-- /line -->
            <div class="table-container col-block">
              <div class="thead">
                <div class="tr row-block">
                  <div
                    v-for="(option, index) in tableOptions"
                    :key="index"
                    class="th row-block"
                    :class="[{ sortable: option.sortMap !== null }, (option.class || (() => []))(null, -1, null)]"
                    :style="{ width: tableWidths[index].value + tableWidths[index].grab + 'px' }"
                    @click="e => !sort.disabled && option.sortMap !== null && tableSortBy(option.sortValue || option.value)"
                  >
                    <template v-if="option.value === '_SELECT'">
                      <div class="_SELECT center-block">
                        <img :src="selectedTableDatas.length ? !filtedCaseDatas.some(data => !selectedDataMap[data.id]) ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-minus.svg') : require('../../assets/images/checkbox-false.svg')" alt="" @click="e => tableOnSelect(null, 'all')">
                      </div>
                    </template>
                    <template v-else>
                      <span class="ellipsis">{{ option.title }}</span>
                      <template v-if="option.sortMap !== null">
                        <div :style="{ width: '5px' }"></div>
                        <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.sortValue || option.value)] || '')]" aria-hidden="true"></i>
                      </template>
                    </template>
                    <div
                      v-if="index + 1 > staticTableWidths[0].length && tableOptions[index + 1 + staticTableWidths[1].length]"
                      class="grab-box grab-x"
                      :class="{ grabbing: boardData['board1'].grabID === index }"
                      :grab-id="index"
                      :grab-type="'x' + { line: '', grab: '*' }[boardType['board1']]"
                      :grab-x-min="tableWidths.slice(0, index).reduce((s, c) => s + c.value, 0) + (option.minWidth || tableMinWidths) + '*'"
                      :grab-x-max="tableWidths.reduce((s, c) => s + c.value, 0) - tableOptions.slice(index + 1, tableOptions.length - staticTableWidths[1].length).reduce((s, c) => s + (c.minWidth || tableMinWidths), 0) - staticTableWidths[1].reduce((s, c) => s + c, 0) + '*'"
                      :grab-x-custom="tableWidths.slice(0, index).reduce((s, c) => s + c.value, 0) + { line: '', grab: '*' }[boardType['board1']]"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div ref="custom-table-scroll" class="table-group-container col-block width-full">
              <div class="col-block">
                <div class="table-container col-block" v-for="(group, gindex) in tableDatas" :key="gindex">
                  <div class="tbody">
                    <div class="tr group row-block" :class="{ selected: group.datas.some(data => (selectedTableData || {}).id === data.id) }" :style="group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' }">
                      <a class="container-block row-block">
                        <div class="bar"></div>
                        <div
                          v-for="(option, index) in tableOptions"
                          :key="index"
                          class="td row-block"
                          :class="(option.class || (() => []))(group[option.gValue], gindex, group)"
                          :style="{ width: tableWidths[index].value + tableWidths[index].grab - (!tableOptions[index + 1] && tableOverflow ? scrollbarSize : 0) + 'px' }"
                        >
                          <template>
                            <span
                              :style="(option.gstyle || (() => ({})))(group[option.gValue], gindex, group)"
                              :title="((option.gdisplay || (x => x))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')"
                              v-html="(option.gdisplay || (x => x))(group[option.gValue], gindex, group) || option.gempty || ''"
                            ></span>
                          </template>
                          <template v-if="option.sortMap !== null && (option.class || (() => []))(group[option.gValue], gindex, group).includes('center') && !(option.class || (() => []))(group[option.gValue], gindex, group).includes('auto-width')">
                            <div :style="{ width: '5px' }"></div>
                            <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.sortValue || option.value)] || '')]" aria-hidden="true" :style="{ opacity: 0 }"></i>
                          </template>
                        </div>
                      </a>
                    </div>
                    <div class="tr col-block" :class="{ selectable: false, selected: (selectedTableData || {}).id === data.id }" v-for="(data, dindex) in group.datas" :key="dindex">
                      <a class="container-block row-block" :style="{ flex: 1 }" @click="e => false && (selectedTableData = data)">
                        <div class="bar"></div>
                        <div
                          v-for="(option, index) in tableOptions"
                          :key="index"
                          class="td row-block"
                          :class="(option.class || (() => []))(data[option.value], dindex, data)"
                          :style="{ width: tableWidths[index].value + tableWidths[index].grab - (!tableOptions[index + 1] && tableOverflow ? scrollbarSize : 0) + 'px' }"
                        >
                          <template v-if="option.value === '_SELECT'">
                            <div class="_SELECT center-block">
                              <img :src="data.selected ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-false.svg')" alt="" @click="e => tableOnSelect([data], !data.selected)">
                            </div>
                          </template>
                          <template v-else>
                            <span
                              :style="(option.style || (() => ({})))(data[option.value], dindex, data)"
                              :title="((option.display || (x => x))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')"
                              v-html="(option.display || (x => x))(data[option.value], dindex, data) || option.empty || '- -'"
                            ></span>
                          </template>
                          <template v-if="(option.description || (() => {}))(data[option.value])">
                            <span
                              :style="{ flex: 'inherit' }"
                              v-html="(option.description || (() => {}))(data[option.value])"
                            ></span>
                          </template>
                          <template v-if="option.sortMap !== null && (option.class || (() => []))(data[option.value], dindex, data).includes('center') && !(option.class || (() => []))(data[option.value], dindex, data).includes('auto-width')">
                            <div :style="{ width: '5px' }"></div>
                            <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.sortValue || option.value)] || '')]" aria-hidden="true" :style="{ opacity: 0 }"></i>
                          </template>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="table-page-container row-block" :style="{ height: '50px' }">
        <div class="options-container input-group row-block" :style="{ flex: 1 }">
          <div :style="{ flex: 1 }"></div>
          <div class="display-container row-block">
            <div class="display-title">{{ $t(pageDisplay.display) }}</div>
            <div :style="{ width: '10px' }"></div>
            <div>
              <select class="display" v-model="pageData.display">
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
              </select>
            </div>
          </div>
        </div>
        <div class="options-container input-group row-block">
          <pageButtons
            :default="pageData.selectedPage"
            :display="pageData.display - 0"
            :total="totalPage * pageData.display"
            :buttonRange="pageData.buttonRange"
            @selectPage="page => { pageData.selectedPage = page }"
          ></pageButtons>
        </div>
        <div class="options-container input-group row-block" :style="{ flex: 1 }">
          <div class="jump-container row-block">
            <div class="jump-title">{{ $t(pageDisplay.jump) }}</div>
            <div :style="{ width: '10px' }"></div>
            <select class="jump" v-model="pageData.pageJumpTo" @change="e => pageData.selectedPage = pageData.pageJumpTo - 0">
              <option v-for="(value, index) in (new Array(totalPage)).fill('').map((_, i) => i + 1)" :key="index" :value="value">{{ value }}</option>
            </select>
          </div>
          <div :style="{ flex: 1 }"></div>
        </div>
      </div>
    </template>
    <template v-else>
      <div :style="{ height: '10px' }"></div>
      <div class="table-page-container row-block"></div>
    </template>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___return') }}</span>
      </button>
      <button v-if="cases.length" class="main-button circle-button" @click="e => $emit('changeModal', {}, Object.keys(selectedDataMap).map(id => id - 0))">
        <span>{{ $t('COMMON.button.___add') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import pageButtons from '../../components/tool/pageButtons.vue'
import customGrab from '../../mixins/customGrab.vue'
import responsitive from '../../mixins/responsitive.vue'
import { dateFormat, groupBy, sortData, toPriceString } from '../../constants/global/util'
import { pageDisplay } from '../../constants/global/data'

export default {
  components: {
    pageButtons
  },
  mixins: [
    customGrab,
    responsitive
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      query: '',
      selectedTableData: null,
      selectedTableDatas: [],
      // table
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [
        [
          40,
          172,
          66,
          66,
          152,
          152
        ],
        [
        ]
      ],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      // page
      displayPage: 1,
      pageData: {
        selectedPage: 1,
        display: 20,
        total: null,
        buttonRange: 7,
        pageJumpTo: ''
      },
      // grab
      boardType: {
        'board1': 'line'
      },
      boardData: {
        'board1': {
          onStart: this.boardResponse('board1', 'start'),
          onMove: this.boardResponse('board1', 'move'),
          onEnd: this.boardResponse('board1', 'end')
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'scrollState'
    ]),
    filtedCaseDatas () {
      let filtedCaseDatas = [...this.cases]
      filtedCaseDatas = sortData(
        (this.cases || []).filter(data => {
          return (
            !this.selectedDataMap[data.id] &&
            [
              data.case_id,
              ...data.phenotypeDatas.map(phenotypeData => phenotypeData.query)
            ].join('ゐ').includes(this.query))
        }),
        this.sort.value.map(x => this.sortMap[x]),
        this.sort.order.map(x => x.replace('-', ''))
      )
      filtedCaseDatas = filtedCaseDatas.filter((_, i) => i >= (this.pageData.display * (this.displayPage - 1)) && i < (this.pageData.display * this.displayPage))
      return filtedCaseDatas
    },
    tableDatas () {
      let tableDatas = [
        ...sortData(
        Object.values(this.selectedDataMap),
        this.sort.value.map(x => this.sortMap[x]),
        this.sort.order.map(x => x.replace('-', ''))
      ),
        ...this.filtedCaseDatas.filter(data => !this.selectedDataMap[data.id])
      ]
      tableDatas = groupBy(tableDatas, () => 'default').map(datas => ({ title: datas[0].group, isGroup: true, datas: datas }))
      return tableDatas
    },
    selectedDataMap () {
      return this.selectedTableDatas.reduce((map, data) => ({ ...map, [data.id]: { ...data, selected: true } }), {})
    },
    sortMap () {
      return this.tableOptions.reduce((s, c) => ({ ...s, ...{ [c.value]: c.sortMap || c.value } }), {})
    },
    totalPage () {
      this.pageData.selectedPage = 1
      return Math.ceil(Math.min(this.cases.length, this.pageData.display * 5000) / this.pageData.display)
    },
    // static
    tableOptions () {
      return [
        {
          value: '_SELECT',
          class: () => ['center'],
          sortMap: null
        },
        {
          title: this.$t('DIALOG.datasetSelectCase.table.title.___caseID'),
          value: 'case_id'
        },
        {
          title: this.$t('DIALOG.datasetSelectCase.table.title.___sex'),
          value: 'sex',
          class: () => ['center'],
          display: value => ({ Male: 'M', Female: 'F', Unknown: 'U' }[value]),
          style: value => ({ Male: { color: '#003679' }, Female: { color: '#BE0F0F' }, Unknown: { color: '#333333' } }[value])
        },
        {
          title: this.$t('DIALOG.datasetSelectCase.table.title.___birthYear'),
          value: 'birth_year',
          class: () => ['center'],
          display: value => value ? ((new Date()).getFullYear() - value + '') : null
        },
        {
          title: this.$t('DIALOG.datasetSelectCase.table.title.___createdAt'),
          value: 'created_at',
          display: value => value ? dateFormat(new Date(value), 'yyyy/MM/dd hh:mm') : value
        },
        {
          title: this.$t('DIALOG.datasetSelectCase.table.title.___updatedAt'),
          value: 'updated_at',
          display: value => value ? dateFormat(new Date(value), 'yyyy/MM/dd hh:mm') : value
        },
        {
          title: this.$t('DIALOG.datasetSelectCase.table.title.___phenotypeDatas'),
          value: 'phenotypeDatas',
          description: value => (value || []).length > 1 ? ('& ' + this.$t(pageDisplay.item, value.length, { count: value.length - 1 })) : '',
          style: value => ({ 'font-weight': 'bold' }),
          display: value => value ? (value[0] || {}).query : value,
          sortMap: null
        },
        {
          title: this.$t('DIALOG.datasetSelectCase.table.title.___genePanels'),
          value: 'gene_panels',
          description: value => (value || []).length > 1 ? ('& ' + this.$t(pageDisplay.item, value.length, { count: value.length - 1 })) : '',
          style: value => ({ 'font-weight': 'bold' }),
          display: value => value ? (value[0] || {}).name : value,
          sortMap: null
        }
      ]
    },
    // param
    cases () {
      return this.param.cases
    },
    // global
    pageDisplay () { return pageDisplay },
    toPriceString () { return toPriceString }
  },
  watch: {
    // data
    'selectedTableData' (nv, ov) {
      if (nv !== ov && JSON.stringify(nv) !== JSON.stringify(ov)) {
        this.selectedTableData = nv ? JSON.parse(JSON.stringify(nv)) : null
      }
    },
    // table
    'tableDatas' () {
      this.getTableOverflow()
    },
    'windowWidth' (nv) {
      this.getTableWidths(nv)
      this.getTableOverflow()
    },
    // page
    'pageData.selectedPage' () {
      if (this.pageData.selectedPage) {
        this.displayPage = this.pageData.selectedPage
        setTimeout(() => { this.pageData.selectedPage = 0 })
      }
    }
  },
  methods: {
    // table
    tableOnSelect (datas, value) {
      if (value === 'all') {
        if (!this.filtedCaseDatas.some(data => !this.selectedDataMap[data.id])) {
          datas = this.selectedTableDatas
          value = false
        } else {
          datas = this.filtedCaseDatas
          value = true
        }
      }
      let dataMap = datas.reduce((map, data) => ({ ...map, [data.id]: data }), {})
      this.selectedTableDatas = value ? [...datas.filter(data => !this.selectedDataMap[data.id]), ...this.selectedTableDatas] : this.selectedTableDatas.filter(result => !dataMap[result.id])
    },
    getTableOverflow () {
      setTimeout(() => {
        let scrollContainer = this.$refs['custom-table-scroll']
        if (scrollContainer) {
          this.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight
        }
      })
    },
    getTableWidths (windowWidth) {
      window.dispatchEvent(new Event('scroll'))
      let tableWidth = Math.min(windowWidth - (20 * 2), 1208) - (22 * 2) - (this.scrollState.height ? this.scrollbarSize : 0)
      tableWidth = tableWidth - this.staticTableWidths[0].reduce((s, c) => s + c, 0) - this.staticTableWidths[1].reduce((s, c) => s + c, 0)
      let tableWidths = this.tableWidths || [
        ...this.staticTableWidths[0],
        1,
        1,
        ...this.staticTableWidths[1]
      ].map(width => ({
        value: width
      }))
      let tableMinWidths = this.tableMinWidths || 0.1
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length)
      let ratio = tableWidth / tableWidths.reduce((s, c) => s + c.value, 0)
      tableWidths = Array.prototype.concat.apply([], [
        this.staticTableWidths[0].map(width => ({
          value: width,
          grab: 0
        })),
        tableWidths.map(width => ({
          value: width.value * ratio,
          grab: 0
        })),
        this.staticTableWidths[1].map(width => ({
          value: width,
          grab: 0
        }))
      ])
      this.tableMinWidths = tableMinWidths * ratio
      this.tableWidths = tableWidths
    },
    tableSortBy (value) {
      let position = this.sort.value.indexOf(value)
      if (position === 0) {
        let order =
          this.sort.order[position] === '-asc' ? '-desc' : '-asc'
        this.sort.order.splice(position, 1)
        this.sort.order.unshift(order)
      } else {
        let order =
          position !== -1
            ? this.sort.order[position] === '-asc' ? '-desc' : '-asc'
            : undefined
        position = position !== -1 ? position : 0
        this.sort.value.splice(position, 1)
        this.sort.order.splice(position, 1)
        this.sort.value.unshift(value)
        this.sort.order.unshift(order || '-asc')
      }
    },
    // grab
    boardResponse (id, type) {
      return {
        'board1': {
          'start': boardData => {
            this.sort.disabled = true
          },
          'move': boardData => {
            if (this.boardType['board1'] === 'grab') {
              let grabID = this.boardData[id].grabID
              let tableWidths = [...this.tableWidths]
              let result = boardData.grabX - boardData.baseX
              let ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - this.staticTableWidths[1].length).reduce((s, c, i) => s + c.value - (this.tableOptions[i].minWidth || this.tableMinWidths), 0)
              tableWidths.forEach((_, i) => {
                if (i === grabID) {
                  tableWidths[i].grab = result
                } if (i > grabID && i + this.staticTableWidths[1].length < tableWidths.length) {
                  tableWidths[i].grab = -(result * ((tableWidths[i].value - (this.tableOptions[i].minWidth || this.tableMinWidths)) / ratioBase))
                }
              })
              this.tableWidths = tableWidths
            }
          },
          'end': boardData => {
            let grabID = this.boardData[id].grabID
            let tableWidths = [...this.tableWidths]
            let result = boardData.grabX - boardData.baseX
            let ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - this.staticTableWidths[1].length).reduce((s, c, i) => s + c.value - (this.tableOptions[i].minWidth || this.tableMinWidths), 0)
            tableWidths.forEach((_, i) => {
              tableWidths[i].grab = 0
              if (i === grabID) {
                tableWidths[i].value += result
              } if (i > grabID && i + this.staticTableWidths[1].length < tableWidths.length) {
                tableWidths[i].value -= result * ((tableWidths[i].value - (this.tableOptions[i].minWidth || this.tableMinWidths)) / ratioBase)
              }
            })
            this.tableWidths = tableWidths
            setTimeout(() => { this.sort.disabled = false })
          }
        }
      }[id]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/datasetSelectCase.vue